module.exports = __webpack_public_path__ + "static/media/background-l6.20956129.png";